module.exports = __webpack_public_path__ + "static/media/mk.3ba4447b.png";